/*!
 * All material copyright ESRI, All Rights Reserved, unless otherwise specified.
 * See https://github.com/Esri/calcite-design-system/blob/dev/LICENSE.md for details.
 * v2.13.2
 */
export const DURATION = 6000;
export const CSS = {
    container: "container",
    containerOverlaid: "container--overlaid",
    containerEdged: "container--edged",
    itemContainer: "item-container",
    itemContainerForward: "item-container--forward",
    itemContainerBackward: "item-container--backward",
    pagination: "pagination",
    paginationItems: "pagination-items",
    paginationItem: "pagination-item",
    paginationItemIndividual: "pagination-item--individual",
    paginationItemVisible: "pagination-item--visible",
    paginationItemOutOfRange: "pagination-item--out-of-range",
    paginationItemSelected: "pagination-item--selected",
    paginationItemRangeEdge: "pagination-item--range-edge",
    pageNext: "page-next",
    pagePrevious: "page-previous",
    autoplayControl: "autoplay-control",
    autoplayProgress: "autoplay-progress",
};
export const ICONS = {
    chevronLeft: "chevron-left",
    chevronRight: "chevron-right",
    inactive: "bullet-point",
    active: "bullet-point-large",
    pause: "pause-f",
    play: "play-f",
};
export const centerItemsByBreakpoint = {
    medium: 7,
    small: 5,
    xsmall: 3,
    xxsmall: 1,
};
//# sourceMappingURL=resources.js.map
